export default {

    SET_DRY_RUN(state, result) {
        state.lastDryRun = result
    },

    SET_SYNC_RESULT(state, result) {
        state.lastSyncResult = result
    },

    SET_MOCO_SETTINGS(state, settings) {
        state.mocoSettings = settings
    }

}
